var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var themeSet = {
    original: {
        colors: {
            dice: "#d9d9d9",
            plainText: "#fff",
            labelText: "#a6b2cb",
            background: "#161718",
            altBackground: "#2a2c2e",
            actionBackground: "#2e3339",
            positiveActionBackground: "#424952",
            altActionBackground: "#6d6d6d",
            altBackgroundOverlay: "#222324",
            positiveCtxBackground: "#55d08f",
            negativeCtxBackground: "#2a2c2e",
            disabled: "#464D56",
            jaguar: "#33383C",
        },
        gradients: {
            positiveCtxGradientStart: "#efd60e",
            positiveCtxGradientEnd: "#50cf92",
            negativeCtxGradientStart: "#ff537a",
            negativeCtxGradientEnd: "#ee51f1",
            cashoutGradientStart: "#EF790D",
            cashoutGradientEnd: "#FFBD2F",
        },
        attributes: {
            borderRadius: "9px",
            boxShadow: "rgba(35, 238, 136, 0.3) 0px 0px 9px",
        },
        fonts: ["Inter"],
    },
};
export var themes = {
    original: {
        colors: __assign({}, themeSet.original.colors),
        gradients: __assign({}, themeSet.original.gradients),
        attributes: __assign({}, themeSet.original.attributes),
        fonts: __spreadArray([], themeSet.original.fonts, true),
        components: {
            buttons: {
                action: {
                    height: "50px",
                    font: themeSet.original.fonts[0],
                    fontWeight: 900,
                    backgroundColor: "linear-gradient(90deg,\n            ".concat(themeSet.original.gradients.positiveCtxGradientStart, " 0%,\n            ").concat(themeSet.original.gradients.positiveCtxGradientEnd, " 100%)"),
                    textColor: themeSet.original.colors.background,
                    borderRadius: themeSet.original.attributes.borderRadius,
                    boxShadow: themeSet.original.attributes.boxShadow,
                },
                cashout: {
                    height: "50px",
                    font: themeSet.original.fonts[0],
                    fontWeight: 900,
                    backgroundColor: "linear-gradient(90deg,\n            ".concat(themeSet.original.gradients.cashoutGradientStart, " 0%,\n            ").concat(themeSet.original.gradients.cashoutGradientEnd, " 100%)"),
                    textColor: themeSet.original.colors.plainText,
                    borderRadius: themeSet.original.attributes.borderRadius,
                    boxShadow: themeSet.original.attributes.boxShadow,
                },
                randomSelect: {
                    height: "50px",
                    font: themeSet.original.fonts[0],
                    fontWeight: 900,
                    backgroundColor: themeSet.original.colors.jaguar,
                    textColor: themeSet.original.colors.plainText,
                    borderRadius: themeSet.original.attributes.borderRadius,
                    boxShadow: themeSet.original.attributes.boxShadow,
                },
                inputButton: {
                    height: "28px",
                    font: themeSet.original.fonts[0],
                    fontWeight: 700,
                    backgroundColor: themeSet.original.colors.actionBackground,
                    textColor: themeSet.original.colors.plainText,
                    borderRadius: themeSet.original.attributes.borderRadius,
                },
                inputButtonLarge: {
                    height: "34px",
                    font: themeSet.original.fonts[0],
                    fontWeight: 700,
                    backgroundColor: themeSet.original.colors.actionBackground,
                    textColor: themeSet.original.colors.plainText,
                    borderRadius: themeSet.original.attributes.borderRadius,
                },
                infoButtonPositive: {
                    height: "44px",
                    font: themeSet.original.fonts[0],
                    fontWeight: 700,
                    backgroundColor: themeSet.original.colors.positiveCtxBackground,
                    textColor: themeSet.original.colors.background,
                    borderRadius: themeSet.original.attributes.borderRadius,
                },
                infoButtonNegative: {
                    height: "44px",
                    font: themeSet.original.fonts[0],
                    fontWeight: 700,
                    backgroundColor: themeSet.original.colors.negativeCtxBackground,
                    textColor: themeSet.original.colors.plainText,
                    borderRadius: themeSet.original.attributes.borderRadius,
                },
            },
            inputs: {
                default: {
                    height: "38px",
                    font: themeSet.original.fonts[0],
                    fontWeight: 700,
                    backgroundColor: themeSet.original.colors.background,
                    textColor: themeSet.original.colors.plainText,
                    placeholderColor: themeSet.original.colors.altActionBackground,
                    disabledColor: themeSet.original.colors.altActionBackground,
                    borderColor: themeSet.original.colors.altBackground,
                    borderFocusColor: themeSet.original.colors.positiveCtxBackground,
                    borderRadius: themeSet.original.attributes.borderRadius,
                },
            },
            selects: {
                default: {
                    height: "32px",
                    fontSize: "11px",
                    outerBorder: "9px",
                    innerBorder: "6px",
                },
                large: {
                    height: "48px",
                    fontSize: "14px",
                    outerBorder: "12px",
                    innerBorder: "9px",
                },
            },
        },
    },
};
//# sourceMappingURL=ThemeProvider.themes.js.map